export default __webpack_public_path__ + "static/popup.light-754923613dc2d0d7522cd028707f7e4a1e9d60a26467435170ec5a22aa34157d.png";